import { Component } from '@angular/core';
import {environment} from "@environment";

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss'
})
export class CookiePolicyComponent {
  environment: any = environment;

}
